import * as React from 'react';

type HeaderAction = React.ReactNode;
const Ctx = React.createContext<{ register: (action: HeaderAction) => void }>({
  register: () => {},
});

export function useSettingsHeaderAction(action: React.ReactNode) {
  const { register } = React.useContext(Ctx);
  // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only effect; action is stable JSX, register is stable context
  React.useEffect(() => {
    register(action);
    return () => register(null);
  }, []); // only on mount/unmount — action is stable because it's JSX inline
}

export function SettingsHeaderProvider({
  onHeaderAction,
  children,
}: {
  onHeaderAction: (action: React.ReactNode) => void;
  children: React.ReactNode;
}) {
  const register = React.useCallback((a: HeaderAction) => onHeaderAction(a), [onHeaderAction]);
  return <Ctx.Provider value={{ register }}>{children}</Ctx.Provider>;
}
